export default function () {
    return {
        isStickyBarShow: false,
        checkVisibility() {
            const isDesktop = window.innerWidth > 768;
            const targetElement = isDesktop
                ? document.getElementById('dynamic-navigation-container')
                : document.getElementById('product-addtocart-button');

            if (targetElement) {
                const rect = targetElement.getBoundingClientRect();
                this.isStickyBarShow = rect.top < 0;
            }
        }
    };
}
